/**
 * Created by claudio iozzia on 29/06/2017.
 */
import {Utils} from "../../../../common/utils";
import {AcceptorOutputFn, andAcceptorSingle} from "../../../../models/acceptor/IAcceptor";
import {Ic} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {ISingleOutput} from "../../../../models/ISpec";
import {acceptSingle_common_Iout} from "./dcdc__common_acceptor";
import {Acceptor_DcDc_BuckBoost} from "./dcdc_buck_boost_acceptor";

export class Acceptor_DcDc_798xBuckBoost extends Acceptor_DcDc_BuckBoost {

  constructor (ledDcDc: boolean= false) {super(ledDcDc); }

  private acceptSingle_798xBuckBoost_Iout: AcceptorOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    const idealDuty: number 	= out.voltage / (out.voltage + spec.spec.value.input.min);
    const Isw: number 		= out.current / ( 1 - idealDuty);
    return  (Utils.isValueEmpty(out.voltage) ||
              Utils.isValueEmpty(spec.spec.value.input.min) ||
              Utils.isValueEmpty(out.current) ||
              Utils.isValueEmpty(Isw) || Isw < a.iout_max);
  }

  protected singleOutputI(): AcceptorOutputFn {return andAcceptorSingle([acceptSingle_common_Iout, this.acceptSingle_798xBuckBoost_Iout]); }
}
